export default __webpack_public_path__ + "static/media/screen4.fc0cc095.png";